import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector, useIsSelfRegistered } from '@/hooks';
import { useGetUserInfoQuery } from '@/store/api/userApi';
import { isGuestUser } from '@/utils';

const SelfRegisteredRoute = () => {
  const isSelfRegistered = useIsSelfRegistered();
  const isGuest = isGuestUser();
  const hasUserInfo = useAppSelector((state) => Boolean(state.user.info ?? state.user.profile));
  // Shares the Header's request. On a reload of /deposit or /withdraw the user isn't known yet;
  // wait for it instead of sending everyone home.
  const { isError } = useGetUserInfoQuery(undefined, { skip: isGuest });

  if (!isGuest && !hasUserInfo && !isError) {
    return (
      <div className="flex justify-center py-20">
        <span className="size-8 animate-spin rounded-full border-2 border-gold border-t-transparent" />
      </div>
    );
  }

  if (!isSelfRegistered) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default SelfRegisteredRoute;
